import PropTypes from "prop-types";
import React from "react";
import { connect, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/cartActions";
import { useTranslation } from "react-i18next";
import { LIST_TYPE_FEATURED } from "../../constants/FeaturedProductsConstants";
import BannerTitle from "../core/BannerTitle";
import { SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { SliderWrapper } from "../../styles/SharedStyles";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import { styles } from "../../utils/theme";
import { device } from "../../utils/breakpoints";
import ProductGridRelated from "./ProductGridRelated";
import useIsMobile from "../hooks/useIsMobile";

SwiperCore.use([Navigation, Pagination]);

const RelatedProducts = ({
  products,
  addToCart,
  cartItems,
  spaceBottomClass,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const featuredProductsLists = useSelector(
    (state) => state.firestoreReducer.ordered.featuredProducts,
  );
  const featuredList = featuredProductsLists.find(
    (item) => item.type === LIST_TYPE_FEATURED,
  );

  return (
    <Wrapper>
      <Container fluid>
        <BannerTitle mb>{t("related_products")}</BannerTitle>
        <SliderWrapper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            350: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          }}
          navigation={!isMobile}
          pagination={isMobile}
        >
          {products.map((product, index) => {
            let isFeaturedProduct = false;
            if (!!featuredList) {
              if (
                featuredList.products.length > 0 &&
                featuredList.products.includes(product.id)
              )
                isFeaturedProduct = true;
            }
            return (
              <SwiperSlide key={product?.id}>
                <ProductGridRelated
                  product={product}
                  addToCart={addToCart}
                  cartItems={cartItems}
                  index={index}
                  isFeatured={isFeaturedProduct}
                />
              </SwiperSlide>
            );
          })}
        </SliderWrapper>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-top: ${styles.banner_padding_mobile};
  padding-bottom: ${styles.banner_padding_mobile};

  @media ${device.lg} {
    padding-top: ${styles.banner_padding_desktop};
    padding-bottom: ${styles.banner_padding_desktop};
  }

  .swiper-container {
    @media ${device.maxMd} {
      padding-bottom: 1rem;
    }
  }
`;

RelatedProducts.propTypes = {
  products: PropTypes.array,
  addToCart: PropTypes.func,
  cartItems: PropTypes.array,
  spaceBottomClass: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (item, quantityCount, variation, type) => {
      dispatch(addToCart(item, quantityCount, variation, type));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedProducts);
